import { useState, useRef, useEffect, forwardRef } from "react";
import { View, TouchableOpacity, Image, Text } from "react-native";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import Carousel from "react-native-reanimated-carousel";
import { Images } from "assets";
import Buttons from "components/Buttons";
import { Link } from "expo-router";
import { useLocalSearchParams } from "expo-router";

const OutfitSilder = forwardRef(({ item, _exploreLookCommonModalRef }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const maxIndex = item?.length;
  const local = useLocalSearchParams();
  const gender = local?.gender ?? "female";
  const [isDisabled, setIsDisabled] = useState(false);
  const carouselRef = useRef(null);
  useEffect(() => {
    let activeIndex1 = activeIndex;
    let leftItems = maxIndex - activeIndex1 - 5;
    leftItems = leftItems < 0 ? 0 : leftItems;
    if (leftItems < 5) {
      //   carouselRef.current?.next({ count: leftItems });
    } else {
    }
    if (isDisabled) {
      setTimeout(() => {
        setIsDisabled(false);
      }, 650);
    }
  }, [activeIndex, isDisabled]);

  const handlePrev = () => {
    setIsDisabled(true);
    let activeIndex1 = activeIndex;
    let itemsToGoBack = activeIndex1 - 5;
    itemsToGoBack = itemsToGoBack < 0 ? activeIndex1 : 5;
    carouselRef.current?.prev({ count: itemsToGoBack });
  };

  const handleNext = () => {
    setIsDisabled(true);
    let activeIndex1 = activeIndex;
    let leftItems = maxIndex - activeIndex1 - 5;
    leftItems = leftItems < 0 ? 0 : leftItems;
    if (leftItems < 5) {
      carouselRef.current?.next({ count: leftItems });
    } else {
      carouselRef.current?.next({ count: 5 });
    }
  };

  return (
    <View>
      {/* Left Arrow */}
      {activeIndex > 0 && (
        <TouchableOpacity
          disabled={isDisabled}
          style={{
            position: "absolute",
            left: -20,
            top: 110,
            display: activeIndex > 0 ? "flex" : "none",
            zIndex: 1000,
          }}
          onPress={handlePrev}
        >
          <Image
            accessibilityLabel="Left Arrow"
            style={{ width: wp(20), height: hp(20) }}
            source={Images.leftArrow}
          />
        </TouchableOpacity>
      )}
      {/* Carousel */}
      <Carousel
        ref={carouselRef}
        loop={false}
        width={wp(140)}
        height={hp(162)}
        pagingEnabled
        style={{ width: wp(140) * 5, pointerEvents: "auto", cursor: "pointer" }}
        autoPlay={false}
        autoPlayInterval={2000}
        userInteractions={true}
        data={item}
        renderItem={({ item }) => (
          <View style={{ width: wp(100), marginHorizontal: spH(10) }}>
            <Link
              href={`/product?id=${item?.id}&brand=${item?.brandName}&product=${item?.productName}&gender=${gender}`}
              target="blank"
            >
              <Image
                accessibilityLabel="Chat Carousel Image"
                source={item?.imageUrls[0]}
                style={{
                  width: wp(125),
                  height: hp(164),
                  borderWidth: 1,
                  borderColor: "#E7E7E7",
                }}
                resizeMode="contain"
              />
            </Link>
          </View>
        )}
        onSnapToItem={setActiveIndex}
      />
      {/* Right Arrow */}

      {activeIndex + 5 < maxIndex && (
        <TouchableOpacity
          disabled={isDisabled}
          style={{ position: "absolute", right: -20, top: 110, zIndex: 1000 }}
          onPress={handleNext}
        >
          <Image
            accessibilityLabel="Right Arrow"
            source={Images.rightArrow}
            style={{ width: wp(20), height: hp(20) }}
          />
        </TouchableOpacity>
      )}

      {/* Explore the Look Button */}
      <View
        style={{
          width: "100%",
          alignItems: "center",
          paddingHorizontal: spH(8),
          marginBottom: spV(20),
        }}
      >
        <Buttons
          onPress={() => {
            _exploreLookCommonModalRef?.current?.show(item);
          }}
          textStyle={{ fontSize: fp(13), fontWeight: "600", color: "#FFFFFF" }}
          containerStyle={{
            width: "100%",
            height: hp(36),
            marginTop: spV(10),
            // backgroundColor: "#21242799",
            borderWidth: 1,
            borderColor: "#E7E7E7",
          }}
          text={"Explore the Look"}
        />
      </View>
    </View>
  );
});

export default OutfitSilder;
